<template>
  <datatable
    :columns="tableColumns"
    :total="stockBatches.meta.page.total"
    :perPage="stockBatches.meta.page.perPage"
    :currentPage="stockBatches.meta.page.currentPage"
    @pagechanged="onChangePage"
  >
    <template #tbody="{ classes }">
      <tr
        v-for="stockBatch in stockBatches.data"
        :key="stockBatch.id"
        :class="[classes.tr, 'bg-white']"
      >
        <td :class="classes.td">
          <p class="font-bold text-gray-900">
            {{ stockBatch.attributes.code }}

            <span v-if="stockBatch.attributes.product_type === 'free'"
              >(PROMO)</span
            >
          </p>
        </td>
        <td :class="classes.td">
          <p>{{ stockBatch.attributes.pickup_method_label }}</p>
        </td>
        <td :class="classes.td">
          {{ stockBatch.attributes.initial_stock_qty }} /
          {{
            stockBatch.attributes.stock_qty -
            stockBatch.attributes.stock_used_qty
          }}
        </td>
        <td :class="classes.td">
          {{ stockBatch.attributes.expire_at | formatDate }}
        </td>
        <td :class="[classes.td, 'text-center']">
          <p>{{ stockBatch.attributes.is_active ? 'Aktif' : 'Nonaktif' }}</p>
        </td>
      </tr>
    </template>
  </datatable>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapGetters } from 'vuex';

export default {
  mixins: [requestMixin],
  props: {
    productId: String,
  },
  emits: ['update-loading'],
  data() {
    return {
      stockBatches: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    tableColumns() {
      return [
        { id: 'code', name: 'No. Batch' },
        { id: 'type', name: 'Tipe' },
        { id: 'product_qty', name: 'Jumlah' },
        { id: 'expire_at', name: 'Kadaluarsa' },
        { id: 'status', name: 'Status', theadClass: 'text-center' },
      ];
    },
  },
  methods: {
    async loadStockBatches(params) {
      this.$emit('update-loading', true);

      const [res, err] = await this.request(
        `/api/v1/warehouses/${this.me.current_warehouse}/stock-batches`,
        {
          params: {
            'fields[stock-batches]':
              'code,product_type,initial_stock_qty,stock_qty,is_active,stock_used_qty,expire_at,pickup_method_label',
            'page[size]': 5,
            'filter[product_id]': this.productId,
            ...params,
          },
        }
      );

      if (!err) {
        this.stockBatches = res;
      }

      this.$emit('update-loading', false);
    },
    onChangePage(page) {
      this.loadStockBatches({
        'page[number]': page,
      });
    },
  },
  activated() {
    this.loadStockBatches();
  },
};
</script>
